// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gG__K","left":"styles_left__vBPzA","desktopActions":"styles_desktopActions__3SfG4","title":"styles_title__2mqlK"};